// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OrderType from "../entity/OrderType.bs.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as OrderStatus from "../entity/OrderStatus.bs.js";
import * as Date$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as FilterOrderBrand from "../../../../root/crm/filter-order/entity/FilterOrderBrand.bs.js";
import * as FilterOrderSource from "../../../../root/crm/filter-order/entity/FilterOrderSource.bs.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FilterOrderRequestMapper from "../../../../root/crm/filter-order/view/FilterOrderRequestMapper.bs.js";

function decodeOrder(json) {
  return {
          orderId: Json_decode.field("order_id", Json_decode.string, json),
          orderPickupTime: Date$Catalyst.fromJsDate(new Date(Json_decode.field("pickup_time", Json_decode.string, json))),
          orderStatus: OrderStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          orderFare: Json_decode.field("order_fare", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json)
        };
}

function builder(json) {
  return {
          orders: Json_decode.field("order_list", (function (param) {
                  return Json_decode.list(decodeOrder, param);
                }), json)
        };
}

function decodeCustomer(json) {
  var full_name = Json_decode.withDefault("", (function (param) {
          return Json_decode.field("first_name", Json_decode.string, param);
        }), json) + Json_decode.withDefault("NA", (function (param) {
          return Json_decode.field("last_name", Json_decode.string, param);
        }), json);
  return {
          uuid: Json_decode.field("uuid", Json_decode.string, json),
          name: full_name,
          mobile: Json_decode.field("mobile", Json_decode.string, json),
          insti_with_contracted_engagement: Json_decode.field("insti_with_contracted_engagement", Json_decode.bool, json)
        };
}

function decodePartner(json) {
  return {
          msisdn: Json_decode.field("msisdn", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

function decodeOrder$1(json) {
  return {
          order_id: Json_decode.field("order_id", Json_decode.string, json),
          source: FilterOrderSource.fromString(Json_decode.field("source", Json_decode.string, json)),
          customer: Json_decode.field("customer", decodeCustomer, json),
          driver: Json_decode.optional(Json_decode.at({
                    hd: "driver",
                    tl: {
                      hd: "value",
                      tl: /* [] */0
                    }
                  }, decodePartner), json),
          start_address_landmark: Json_decode.field("from_address_landmark", Json_decode.string, json),
          end_address_landmark: Json_decode.field("to_address_landmark", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          created_at: Timestamp$Catalyst.make(Json_decode.field("created_at_millis", Json_decode.$$float, json)),
          pickup_time: Timestamp$Catalyst.make(Json_decode.field("pickup_time_millis", Json_decode.$$float, json)),
          vehicle_type: Json_decode.field("vehicle_type", Json_decode.string, json),
          order_status: OrderStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          order_type: OrderType.fromString(Json_decode.field("order_type", Json_decode.string, json)),
          brand: FilterOrderBrand.fromString(Json_decode.field("brand", Json_decode.string, json))
        };
}

function execute(json) {
  return {
          orders: Json_decode.field("orders", (function (param) {
                  return Json_decode.list(decodeOrder$1, param);
                }), json),
          offset: Json_decode.optional(Json_decode.at({
                    hd: "offset",
                    tl: {
                      hd: "value",
                      tl: /* [] */0
                    }
                  }, Json_decode.string), json),
          total_orders: Json_decode.field("total_count", Json_decode.$$int, json)
        };
}

var FilterOrderResponseMapper = {
  decodeCustomer: decodeCustomer,
  decodePartner: decodePartner,
  decodeOrder: decodeOrder$1,
  execute: execute
};

function decodeGetFilters(json) {
  return {
          name: Json_decode.field("filter_name", Json_decode.string, json),
          filter_props: Json_decode.field("filter_props", FilterOrderRequestMapper.JsonDecoder.execute, json)
        };
}

function execute$1(data) {
  return Json_decode.at({
                hd: "get_filters",
                tl: {
                  hd: "returning",
                  tl: /* [] */0
                }
              }, (function (param) {
                  return Json_decode.list(decodeGetFilters, param);
                }))(data);
}

var FilterQueryResponseMapper = {
  decodeGetFilters: decodeGetFilters,
  execute: execute$1
};

export {
  decodeOrder ,
  builder ,
  FilterOrderResponseMapper ,
  FilterQueryResponseMapper ,
  
}
/* Date-Catalyst Not a pure module */
